import { NodeTypeGroups } from './types';
import { InputValidationConfig } from '../../../utils/validation/inputValidation';

export const DIAGRAM_IMAGE_KEY = 'diagram_image';

/**
 * Validation configuration for report form fields
 */
export const REPORT_FORM_VALIDATION: Record<string, InputValidationConfig> = {
  title: {
    maxLength: 100,
    minLength: 1,
    allowEmpty: false,
    trimWhitespace: false,
  },
  authorName: {
    maxLength: 50,
    minLength: 1,
    allowEmpty: true,
    trimWhitespace: false,
  },
  authorRole: {
    maxLength: 50,
    allowEmpty: true,
    trimWhitespace: false,
  },
  email: {
    maxLength: 100,
    minLength: 5,
    allowEmpty: false,
    trimWhitespace: true,
  },
  searchQuery: {
    maxLength: 50,
    allowEmpty: true,
    trimWhitespace: true,
  }
};

export const NODE_TYPE_GROUPS: NodeTypeGroups = {
  SOURCES: [
    { id: 'mobile-sdk', name: 'Mobile App' },
    { id: 'javascript-source', name: 'Website' },
    { id: 'server-source', name: 'Server/other' }
  ],
  ARCHITECTURE: [
    { id: 'sync-injector', name: 'Sync Injector' },
    { id: 'cluster', name: 'Cluster' },
    { id: 'load-balancer', name: 'Load Balancer' }
  ],
  MODULES: [
    { id: 'consent-enforcement', name: 'Consent Enforcement' },
    { id: 'bot-detection', name: 'Bot Detection' },
    { id: 'data-replay', name: 'Data Replay' },
    { id: 'schema-enforcement', name: 'Schema Enforcement' },
    { id: 'transformations', name: 'Transformations' }
  ],
  TOPICS: [
    { id: 'cdp-enhancement', name: 'CDP Enhancement' },
    { id: 'data-governance', name: 'Data Governance & Compliance' },
    { id: 'tag-management', name: 'Tag Management' },
    { id: 'rmn', name: 'Retail Media Networks' }
  ],
  DESTINATIONS: [] // Will be populated dynamically with destinations from the canvas
};
